import { render } from "./Wellbeing.vue?vue&type=template&id=2ebb8248&scoped=true"
import script from "./Wellbeing.vue?vue&type=script&lang=js"
export * from "./Wellbeing.vue?vue&type=script&lang=js"

import "./Wellbeing.vue?vue&type=style&index=0&id=2ebb8248&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bert\\Documents\\development\\huureenstuur\\hes-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebb8248"]])

export default __exports__